// Auto-split from i18n.js — language: zh_CN
export default {
    translation: {
        // routes & menus
        Dashboard: '总览',
        'Space Data': '空间数据',
        'Equipment Data': '设备数据',
        'Meter Data': '计量表数据',
        'Tenant Data': '租户数据',
        'Store Data': '门店数据',
        'Shopfloor Data': '车间数据',
        'Combined Equipment Data': '组合设备数据',
        'Auxiliary System': '辅助系统',
        Microgrid: '微电网',
        'Energy Storage Power Station': '电站',
        'Photovoltaic Power Station': '电站',
        'Fault Alarm': '故障报警',
        Monitoring: '设备监控',
        'Advanced Reporting': '高级报表',
        'Knowledge Base': '知识库',
        'Energy Category Data': '能耗分类分析',
        'Energy Item Data': '能耗分项分析',
        Carbon: '碳排放分析',
        Cost: '成本分析',
        Output: '产出分析',
        Income: '收入分析',
        Efficiency: '效率分析',
        Load: '负荷分析',
        Statistics: '统计分析',
        'Batch Analysis': '批量分析',
        Saving: '节能分析㊭',
        Plan: '计划分析㊭',
        Prediction: '预测分析㊭',
        'Production': '产量',
        'Space Production': '产量能耗分析',
        'Equipment Tracking': '设备台账',
        'Equipment Comparison': '对比分析',
        'Shopfloor Comparison': '对比分析',
        'Store Comparison': '对比分析',
        'Space Comparison': '对比分析',
        'Combined Equipment Comparison': '对比分析',
        'Tenant Comparison': '对比分析',
        'Environment Monitor': '环境监测',
        'Meter Energy': '计量表能耗分析',
        'Meter Prediction': '计量表预测分析㊭',
        'Virtual Meter Prediction': '虚拟表预测分析㊭',
        'Offline Meter Prediction': '离线表预测分析㊭',
        'Meter Carbon': '计量表碳排放分析',
        'Meter Cost': '计量表成本分析',
        'Meter Trend': '计量表趋势分析',
        'Meter Realtime': '计量表实时分析',
        'Meter Saving': '计量表节能分析㊭',
        'Meter Plan': '计量表计划分析㊭',
        'Master Meter Submeters Balance': '总分表平衡分析',
        'Meter Batch Analysis': '计量表批量分析',
        'Meter Comparison': '计量表对比分析',
        'Meter Tracking': '计量表台账',
        'Virtual Meter Saving': '虚拟表节能分析㊭',
        'Virtual Meter Plan': '虚拟表计划分析㊭',
        'Virtual Meter Energy': '虚拟表能耗分析',
        'Virtual Meter Carbon': '虚拟表碳排放分析',
        'Virtual Meter Cost': '虚拟表成本分析',
        'Virtual Meter Batch Analysis': '虚拟表批量分析',
        'Virtual Meter Comparison': '虚拟表对比分析',
        'Offline Meter Energy': '离线表能耗分析',
        'Offline Meter Carbon': '离线表碳排放分析',
        'Offline Meter Cost': '离线表成本分析',
        'Offline Meter Batch Analysis': '离线表批量分析',
        'Offline Meter Saving': '离线表节能分析㊭',
        'Offline Meter Plan': '离线表计划分析㊭',
        'Offline Meter Input': '离线表数据录入',
        'Tenant Bill': '租户账单',
        'Energy Flow Diagram': '能流图',
        'Distribution System': '配电系统',
        'SVG System': '组态可视化系统',
        'Faults Data': '故障分析',
        'Space Equipments': '空间设备',
        'Combined Equipments': '组合设备',
        'Energy Storage Power Station List': '电站列表',
        'Energy Storage Power Station Details': '设备监控',
        'Energy Storage Power Station Reporting': '数据报表',
        'Energy Storage Power Station Alarm': '故障报警',
        'Energy Storage Power Station Maintenance': '维护保养',
        'Enter Production': '产量录入',
        'Multiple Microgrids': '多站数据',
        'Multiple Microgrids Dashboard': '多站总览',
        'Multiple Microgrids List': '电站列表',
        'Single Microgrid': '单站数据',
        'Single Microgrid Dashboard': '单站总览',
        'Single Microgrid Details': '设备数据',
        'Single Microgrid Fault Alarm': '故障告警',
        'Microgrid Reports': '统计报表',
        'Microgrid Reports Energy': '电量报表',
        'Microgrid Reports Revenue': '收益报表',
        'Microgrid Reports Parameters': '数据查询',
        'Multiple Energy Storage Power Stations': '储能多站数据',
        'Multiple Energy Storage Power Stations Dashboard': '储能多站总览',
        'Multiple Energy Storage Power Stations List': '储能电站列表',
        'Single Energy Storage Power Station': '储能单站数据',
        'Single Energy Storage Power Station Dashboard': '储能单站总览',
        'Single Energy Storage Power Station Details': '储能设备数据',
        'Single Energy Storage Power Station Fault Alarm': '储能故障告警',
        'Energy Storage Power Station Reports': '储能统计报表',
        'Energy Storage Power Station Reports Energy': '储能电量报表',
        'Energy Storage Power Station Reports Revenue': '储能收益报表',
        'Energy Storage Power Station Reports Parameters': '储能数据查询',
        'Photovoltaic Power Station List': '电站列表',
        'Photovoltaic Power Station Details': '设备监控',
        'Photovoltaic Power Station Reporting': '数据报表',
        'Photovoltaic Power Station Alarm': '故障报警',
        'Photovoltaic Power Station Maintenance': '维护保养',
        'Multiple Photovoltaic Power Stations': '多站数据',
        'Multiple Photovoltaic Power Stations Dashboard': '多站总览',
        'Multiple Photovoltaic Power Stations List': '电站列表',
        'Single Photovoltaic Power Station': '单站数据',
        'Single Photovoltaic Power Station Dashboard': '单站总览',
        'Single Photovoltaic Power Station Details': '设备数据',
        'Single Photovoltaic Power Station Fault Alarm': '故障告警',
        'Photovoltaic Power Station Reports': '统计报表',
        'Photovoltaic Power Station Reports Energy': '电量报表',
        'Photovoltaic Power Station Reports Revenue': '收益报表',
        'Photovoltaic Power Station Reports Parameters': '数据查询',
        'Work Order': '工单管理',
        'Work Order Installation': '安装记录',
        'Work Order Repair': '维修记录',
        'Work Order Inspection': '巡检记录',
        'Total Number of Work Orders': '总工单数量',
        'Number of New Work Orders': '新发工单数量',
        'Number of Inprogress Work Orders': '进行中工单数量',
        'Number of Done Work Orders': '已完成工单数量',
        'Fuel Indicator': '耗油量',
        'Charge Energy Indicator': '充电能量',
        'Discharge Energy Indicator': '放电能量',
        'Charge Cost Indicator': '充电成本',
        'Discharge Revenue Indicator': '放电收益',
        'HVAC': '空调',
        'Fire Control': '消防',
        // Tenant Dashboard
        'Tenant Dashboard': '租户仪表板',
        'Comprehensive overview of tenant energy performance': '租户能源绩效综合概览',
        'Total Tenants': '租户总数',
        'Tenant Performance Overview': '租户绩效概览',
        'Tenant Name': '租户名称',
        'Tenant Area': '租户面积',
        'Tenant Type': '租户类型',
        // Equipment Dashboard
        'Equipment Dashboard': '设备仪表板',
        'Total Equipments': '设备总数',
        'Equipment Performance Overview': '设备绩效概览',
        'Equipment Name': '设备名称',
        'Equipment Type': '设备类型',
        'Total Energy': '总能耗',
        'Total Sensors': '传感器总数',
        'Increment Rate': '增长率',
        // Combined Equipment Dashboard
        'Total Combined Equipments': '组合设备总数',
        'Combined Equipment Performance Overview': '组合设备绩效概览',
        'Combined Equipment Name': '组合设备名称',
        'Associated Equipments': '关联设备数',
        // Store Dashboard
        'Store Dashboard': '门店仪表板',
        'Comprehensive overview of store energy performance': '门店能源绩效综合概览',
        'Total Stores': '门店总数',
        'Total Area': '总面积',
        'Active Meters': '活跃电表数',
        'Active Alerts': '活动告警',
        'Total Energy Consumption': '总能耗',
        'Carbon Emissions': '碳排放',
        'Current Period': '当前周期',
        'Energy Consumption by Category': '按类别能耗分布',
        'Cost Distribution by Category': '按类别成本分布',
        'Monthly Energy & Cost Trends': '月度能耗与成本趋势',
        'Top 5 Energy Consuming Stores': '能耗最高的前5家门店',
        'Energy Category Details': '能源类别详情',
        'Store Performance Overview': '门店绩效概览',
        'YoY Change': '同比变化',
        'Per m²': '每平方米',
        'Usage Intensity': '使用强度',
        'Dashboard data loaded successfully': '仪表板数据加载成功',
        'Failed to load dashboard data': '加载仪表板数据失败',
        'Store Name': '门店名称',
        'Store Area': '门店面积',
        'Energy Consumption': '能耗',
        'Consumption': '消耗量',
        'last period': '上期',
        // Shopfloor Dashboard
        'Total Shopfloors': '车间总数',
        'Shopfloor Performance Overview': '车间绩效概览',
        'Shopfloor Name': '车间名称',
        'Shopfloor Area': '车间面积',
        // Dashboard
        'Welcome to QiXuan': '欢迎使用QiXuan',
        'An Industry Leading Energy Management System': '行业领先的能源管理系统',
        "This Year's Consumption CATEGORY VALUE UNIT": '本年消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": '本年成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": '本月消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": '本月产出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Costs CATEGORY VALUE UNIT": '本月成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': '去年同期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '去年同期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} 消耗 {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} 成本 {{UNIT}}',
        // Entities
        Space: '空间',
        Equipment: '设备',
        Meter: '计量表',
        'Offline Meter': '离线表',
        'Virtual Meter': '虚拟表',
        Tenant: '租户',
        Store: '门店',
        Shopfloor: '车间',
        'Combined Equipment': '组合设备',
        'Cost Center': '成本中心',
        Name: '名称',
        DisplayName: '显示名',
        UserName: '用户名',
        Description: '描述',
        'Energy Category': '能源分类',
        'Child Spaces': '子空间',
        'Associated Equipment': '相关设备',
        //Energy Categories
        Electricity: '电',
        Water: '自来水',
        'Natural Gas': '天然气',
        // SidePanelModal
        Settings: '设置',
        'Set your own customized style': '设置您的自定义样式',
        'Color Scheme': '配色方案',
        'Choose the perfect color mode for your app': '为您的应用选择理想的色彩模式',
        Light: '亮色',
        Dark: '暗色',
        'RTL Mode': 'RTL模式',
        'Switch your language direction': '改变你的语言方向',
        'Fluid Layout': '流动布局',
        'Toggle container layout system': '切换容器布局系统',
        'Navigation Position': '导航栏位置',
        'Vertical': '垂直',
        'Top': '顶部',
        'Combo': '组合',
        'Transparent': '透明',
        'Inverted': '反色',
        'Card': '卡片',
        'Vibrant': '活力',
        'Select a suitable navigation system for your web application': '为您的web应用程序选择合适的导航栏系统',
        'Vertical Nav': '垂直导航栏',
        'Top Nav': '顶部导航栏',
        'Vertical Navbar Style': '垂直导航栏样式',
        'Switch between styles for your vertical navbar': '切换垂直导航栏的样式',
        Language: '语言',
        'Switch between languages': '切换语言',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': '喜欢这个系统?',
        'Get QiXuan now': '立即获取QiXuan',
        'PQ.About': '本分析涵盖电压偏差、电压不平衡、频率偏差和电流不平衡。电压偏差按(U−Un)/Un×100%计算；频率偏差按|f−fn|计算；三相不平衡按max(|Xi−Xavg|)/Xavg×100%计算，并要求三相通道时间对齐。结果基于所选计量表在报告期内的时间序列。如果缺少三相通道或时间戳不对齐，将跳过不平衡指标。瞬态尖峰或缺失采样可能放大最差值，稳态评估建议参考合规率与P95等统计指标。',
        Purchase: '采购企业版',
        ContactInfo: '联系方式',
        ProductWebsite: '产品官网',
        CompanyWebsite: '公司官网',
        SalesPhone: '销售电话',
        // Query Panels
        'Base Period Begins': '基准期开始',
        'Base Period Ends': '基准期结束',
        'Comparison Types': '比较类型',
        'Year-Over-Year': '去年同比',
        'Month-On-Month': '上月环比',
        'Free Comparison': '自由比',
        'None Comparison': '不比',
        'Reporting Period Begins': '报告期开始',
        'Reporting Period Ends': '报告期结束',
        '(Optional)': '(可选)',
        'Period Types': '时间尺度',
        Yearly: '年',
        Monthly: '月',
        Weekly: '周',
        Daily: '日',
        Hourly: '时',
        Submit: '提交',
        'Input Energy Category': '消耗能源分类',
        'Output Energy Category': '产出能源分类',
        'Fraction Parameter': '分式参数',
        Search: '搜索',
        //DateRangePicker
        sunday: '日',
        monday: '一',
        tuesday: '二',
        wednesday: '三',
        thursday: '四',
        friday: '五',
        saturday: '六',
        ok: '确定',
        today: '今天',
        yesterday: '昨天',
        hours: '时',
        minutes: '分',
        seconds: '秒',
        last7Days: '最近七天',
        tomorrow: '明天',
        dayAfterTomorrow: '后天',
        next7Days: '今后七天',
        'Select Date Range': '选择日期范围',
        //Card Summaries and Line Charts
        'Base Period': '基准期',
        'Reporting Period': '报告期',
        'Per Unit Area': '单位面积值',
        'Per Capita': '人均值',
        'Per Unit Production': '单位产品值',
        Baseline: '基线值',
        Actual: '实际值',
        'Baseline Value - Actual Value': '基线值-实际值',
        'Average Load': '平均负荷',
        'Maximum Load': '最大负荷',
        'Load Factor': '负荷系数',
        'Ratio of Average Load to Maximum Load': '平均负荷与最大负荷的比值',
        'Carbon Dioxide Emissions by Energy Category': '二氧化碳排放占比',
        'Costs by Energy Category': '成本占比',
        'Incomes by Energy Category': '收入占比',
        'Electricity Consumption by Time-Of-Use': '分时消耗电量',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': '分时用电排放二氧化碳',
        'Electricity Cost by Time-Of-Use': '分时用电成本',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} 分项消耗占比',
        'Ton of Standard Coal by Energy Category': '吨标准煤(TCE)占比',
        'Ton of Carbon Dioxide Emissions by Energy Category': '吨二氧化碳排放(TCO2E)占比',
        'Reporting Period Consumption CATEGORY UNIT': '报告期消耗 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': '报告期预测 {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} 报告期消耗 {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} 报告期消耗 {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': '报告期产量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': '基准期产量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': '报告期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': '报告期预测 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': '基准期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': '报告期预测 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': '报告期消耗 {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '报告期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': '基准期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': '子空间分类占比 {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': '子空间总计占比',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '报告期二氧化碳排放 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            '报告期二氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '基准期二氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': '报告期成本 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': '报告期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': '基准期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': '报告期产出 {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} 报告期产出 {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} 报告期产出 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': '报告期产出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': '基准期产出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': '报告期收入 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': '报告期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': '基准期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': '报告期总收入 {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': '报告期累积效率 {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} 报告期累积效率 {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} 报告期累积综合效率 {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} 报告期累积综合效率 {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} 基准期累积综合效率 {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': '瞬时效率 {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 瞬时效率 {{UNIT}}',
        'Equipment Efficiency Indicator': '设备能效指标',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 瞬时综合效率 {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': '报告期累积效率 {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '报告期累积效率 {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': '基准期累积效率 {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': '基准期累积效率 {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': '基准期 {{CATEGORY}} 最大负荷 {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': '报告期 {{CATEGORY}} 最大负荷 {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': '报告期 {{CATEGORY}} 平均负荷 {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': '报告期 {{CATEGORY}} 负荷系数',
        'Base Period CATEGORY Average Load VALUE UNIT': '基准期 {{CATEGORY}} 平均负荷 {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': '报告期 {{CATEGORY}} 平均值 {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': '报告期 {{CATEGORY}} 最大值 {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': '报告期 {{CATEGORY}} 最小值 {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': '报告期 {{CATEGORY}}  算术平均数 {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': '报告期 {{CATEGORY}} 中位数 {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': '报告期 {{CATEGORY}} 样本标准差 {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': '报告期 {{CATEGORY}} 样本方差 {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '报告期节约 {{CATEGORY}} (基线-实际) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '报告期减少 {{CATEGORY}} (基线-实际) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': '报告期节约 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': '基准期节约 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT': '报告期总表消耗 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '报告期总表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT': '报告期分表消耗 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': '报告期分表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': '报告期差值 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': '报告期差值百分比',
        'Reporting Period Difference CATEGORY VALUE UNIT': '报告期差值 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': '趋势值',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': '故障列表',
        'Reporting Period Number of Fault VALUE': '报告期故障数: {{VALUE}}',
        'All Faults': '全部故障',
        'Space Faults': '空间故障',
        'Number of All Faults': '全部故障数',
        'Number of Space Faults': '空间故障数',
        'Total Number of Faults': '总故障数量',
        'Number of New Faults': '新发故障数量',
        'Number of Inprogress Faults': '进行中故障数量',
        'Number of Done Faults': '已完成故障数量',
        //Data Panels
        'Ton of Standard Coal': '吨标准煤',
        'Ton of Carbon Dioxide Emissions': '吨二氧化碳排放',
        'Carbon Emissions Per Unit Of Energy Consumption': '单位能耗碳排放',
        'Operating Characteristic Curve': '运行曲线',
        Tariff: '费率',
        'Detailed Data': '详细数据',
        'Child Spaces Data': '子空间数据',
        'Associated Equipment Data': '相关设备数据',
        'This Year': '本年',
        'The Same Period Last Year': '去年同期',
        'This Month': '本月',
        'This Day': '本日',
        Total: '总计',
        'No data found': '没有数据',
        Export: '导出',
        'AI Analysis': 'AI分析',
        'AI analysis initial prompt':
            '请仅依据下列报表 JSON 数据：概括主要结论与异常，对比基期与报告期（如有），并给出节能与运维优化建议。请用纯文本分段说明，不要使用 Markdown（不要用 #、**、```、列表符号等）。',
        'AI analysis loading': 'AI 正在分析报表数据…',
        'AI analysis follow up placeholder': '针对本报表继续提问（可选）',
        Send: '发送',
        'AI analysis copy': '复制',
        'AI analysis copied': '已复制到剪贴板',
        'AI analysis copy failed': '复制失败',
        'AI analysis max messages hint': '已达到本会话对话条数上限（最多 5 条）。',
        Datetime: '日期时间',
        'Time-Of-Use Type': '分时类型',
        'Top-Peak': '尖',
        'On-Peak': '峰',
        'Mid-Peak': '平',
        'Off-Peak': '谷',
        'Deep': '深谷',
        Percentage: '百分比',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': '能耗值点最近一小时趋势',
        Circuit: '回路',
        Point: '数据点',
        'Realtime Value': '实时值',
        //Meter Tracking
        'Meter List': '计量表列表',
        'Edit Meter': '编辑',
        'Start Value': '起始值',
        'End Value': '结束值',
        'Difference Value': '差值',
        'Start Integrity Rate': '起始数据完整率(%)',
        'End Integrity Rate': '结束数据完整率(%)',
        'Full Integrity Rate': '整体数据完整率(%)',
        'Start Integrity Rate Description': '起始数据完整率：统计时段内，所有仪表中成功获取到起始时刻能耗读数的仪表占比',
        'End Integrity Rate Description': '结束数据完整率：统计时段内，所有仪表中成功获取到结束时刻能耗读数的仪表占比',
        'Full Integrity Rate Description': '全量数据完整率：统计时段内，同时成功获取到起始、结束时刻能耗读数的仪表占比',
        //Equipment Tracking
        'Equipment List': '设备列表',
        'Edit Equipment': '编辑',
        //Profile Dropdown
        Feedback: '反馈',
        'Account Settings': '账号设置',
        Logout: '退出',
        //Authentication
        'Log in': '登录',
        'Email address': '电子邮件地址',
        'Phone Number': '电话号码',
        Password: '密码',
        CaptchaCode: '验证码',
        Refresh: '刷新',
        'Remember me': '记住我',
        'Logged in as ': '已登录 ',
        'Forgot Password?': '忘记密码?',
        'Forgot your password?': '忘记你的密码?',
        "Enter your email and we'll send you a reset link": '输入电子邮件地址，我们会把重置链接发送给您',
        "Enter your email and we'll send you a registration link": '输入电子邮件地址，我们会把注册链接发送给您',
        'Reset Password': '重置密码',
        'Thanks for using QiXuan!': '感谢您使用QiXuan!',
        'You are now successfully signed out': '您已成功退出',
        'Return to Login': '返回登录',
        'Please check your email!': '请查收您的电子邮件!',
        'An email has been sent to ': '一封电子邮件已经发送至 ',
        'Please click on the included link to reset your password': '请点击里面的链接重置您的密码',
        'Please click on the included link to register your account': '请点击里面的链接注册您的账户',
        'An email with password reset link is sent to ': '一封包含密码重置链接的电子邮件已经发送至 ',
        'Change Password': '修改密码',
        'Old Password': '原密码',
        'New Password': '新密码',
        'Confirm Password': '重复新密码',
        'Update Password': '更新密码',
        'Password has been changed!': '密码已修改!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below.':
            '验证码已发送到您的收件箱，请将其复制到下面的输入框中。',
        'New to QiXuan': '初次使用QiXuan',
        'Create an account': '注册账户',
        'EMAIL Account registration successful': '{{EMAIL}}账号注册成功',
        'Thanks for verifying your account!': '感谢您验证您的账户！',
        'Your code is': '您的代码是',
        'Send verification code': '发送验证码',
        'Please wait for NUMBER seconds': '请等待{{NUMBER}}秒',
        'Password reset': '密码重置',
        'Please wait for approval': '请等待审核',
        //notification
        Notifications: '通知',
        'Mark all as read': '全部设为已读',
        'View all': '全部',
        'Notification New': '新的',
        'Notification Earlier': '更早的',
        'Notification List': '通知列表',
        'Bulk actions': '批量操作',
        'Notification Subject': '主题',
        'Notification Created Datetime': '创建时间',
        'Notification Message': '内容',
        'Notification Priority': '优先级',
        'Notification Status': '状态',
        'Notification Mark As Read': '标记为已读',
        'Notification Mark As Acknowledged': '确认',
        'Notification Low': '低',
        'Notification Medium': '中',
        'Notification High': '高',
        'Notification Critical': '严重',
        'Notification Unread': '未读',
        'Notification Read': '已读',
        'Notification Acknowledged': '已确认',
        'Notification Archive': '存档',
        'Notification Delete': '删除',
        'Notification Apply': '应用',
        'Notification Start Datetime': '开始时间',
        'Notification End Datetime': '结束时间',
        'Notification Update Datetime': '更新时间',
        //Monitoring
        'Run Commands': '运行指令',
        'Pin Code': '密码',
        'Unlock': '解锁',
        'Set Value': '设定值',
        'Fault Alarms': '故障报警',
        'Instantaneous Efficiency VALUE UNIT': '瞬时效率 {{VALUE}} {{UNIT}}',
        'Communication Status': '通信状态',
        'Communication Online': '在线',
        'Communication Offline': '离线',
        'Equipment Status': '设备状态',
        'Equipment Running': '运行',
        'Equipment Stopped': '停机',
        'Show Up to': '每页显示数量',
        All: '全部',
        'FROM - TO of TOTAL': '当前显示{{FROM}} - {{TO}} 总计{{TOTAL}}',
        //Microgrid
        'Microgrid Energy': '电量',
        'Microgrid Revenue': '收益',
        'Microgrid Carbon': '碳排放',
        'Photovoltaic Generation': '光伏发电量',
        'EV Charger Consumption': '充电桩用电量',
        'Load Consumption': '负载用电量',
        'Grid Buy': '从电网购买电量',
        'Grid Sell': '向电网销售电量',
        'EV Charger': '充电桩',
        'Heat Pump': '热泵',
        'Photovoltaic': '光伏',
        'PCS Run State': 'PCS运行状态',
        'PCS Unknown': '未知',
        'PCS Initializing': '初始上电',
        'PCS Standby': '待机',
        'PCS Shutdown': '关机',
        'PCS Fault': '故障',
        'PCS Running': '运行',
        'Battery Power': '电池功率',
        'Photovoltaic Power': '光伏功率',
        'Grid Power': '电网功率',
        'Load Power': '负载功率',
        Reporting: '数据报表',
        Maintenance: '维护保养',
        'General Information': '基本信息',
        'Serial Number': '序列号',
        Address: '地址',
        'Postal Code': '邮编',
        'Rated Capacity': '额定容量',
        'Rated Power': '额定功率',
        Latitude: '纬度',
        Longitude: '经度',
        'Strategy Management': '策略管理',
        'Charging Schedule': '充电时间表',
        'Charge Start Time': '充电开始时间',
        'Charge End Time': '充电结束时间',
        'Discharge Start Time': '放电开始时间',
        'Discharge End Time': '放电结束时间',
        'Total Rated Power': '总额定功率',
        'Total Rated Capacity': '总额定容量',
        // Energy Indicator
        "Today's Charge": "今日充电量",
        "Today's Discharge": "今日放电量",
        "Today's Generation": "今日发电量",
        'Total Fuel Consumption': '总耗油量',
        'Total Charge': '总充电',
        'Total Discharge': '总放电',
        'Total Generation': '总发电量',
        'Total Revenue': '总收益',
        'Total Photovoltaic Generation': '总光伏发电量',
        'Total EV Charger Consumption': '充电桩总用电量',
        'Total Load Consumption': '负载总用电量',
        'Total Grid Buy': '从电网购买总电量',
        'Total Grid Sell': '向电网销售总电量',
        'Total Efficiency': '综合效率',
        'Discharge Achievement Rate': '放电达成率',
        // Revenue Indicator
        "Today's Cost": "今日成本",
        "Today's Income": "今日收入",
        "Total Cost": "累计成本",
        "Total Income": "累计收入",
        "Today's Revenue": "今日盈利",

        'Revenue Ranking': '收益排名',
        'Efficiency Ranking': '效率排名',
        'Charge Ranking': '充电排名',
        'Discharge Ranking': '放电排名',
        'Number of Microgrids': '微电网数',
        'Number of Power Stations': '电站数',
        'Microgrid List': '微电网列表',
        'Select Microgrid': '选择微电网',
        'Previous Page': '上一页',
        'Next Page': '下一页',
        '7 Days': '7日',
        'Charge UNIT': '充 {{UNIT}}',
        'Discharge UNIT': '放 {{UNIT}}',
        'Generation UNIT': '发电 {{UNIT}}',
        'Energy Indicator': '能量',
        'Revenue Indicator': '收益',
        'Carbon Indicator': '碳',

        // Energy Storage Power Station
        'Battery Operating State': '电池运行状态',
        'Battery State': '电池状态',
        'Battery Unknown': '未知',
        'Battery Stopped': '停止',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': '故障', // 1
        'Battery Warning': '预警', // 2
        'Battery Standby': '待机', // 3
        'Battery Prohibit DisCharging': '禁放', // 4
        'Battery Prohibit Charging': '禁充', // 5
        'Battery Normal': '正常', // 6
        'Battery Charging': '充电', // 7
        'Battery Discharging': '放电', // 8
        'Battery Idle': '空闲', // 9
        'Phase of Lifecycle': '阶段',
        'Use Phase': '投用',
        'Commissioning Phase': '调试',
        'Commissioning Date': '启用日期',
        'Installation Phase': '在建',
        'Device Status': '设备状态',
        'Basic Information': '基本信息',
        'Gateway': '网关',
        'Grid Meter': '电网电表',
        'Load Meter': '负载电表',
        'ESS Meter': '储能电表',
        'Total Active Power': '总有功功率',
        'Active Power A': 'A相有功功率',
        'Active Power B': 'B相有功功率',
        'Active Power C': 'C相有功功率',
        'Total Reactive Power': '总无功功率',
        'Reactive Power A': 'A相无功功率',
        'Reactive Power B': 'B相无功功率',
        'Reactive Power C': 'C相无功功率',
        'Total Apparent Power': '总视在功率',
        'Apparent Power A': 'A相视在功率',
        'Apparent Power B': 'B相视在功率',
        'Apparent Power C': 'C相视在功率',
        'Total Power Factor': '总功率因数',
        'Active Energy Import': '正向有功电能',
        'Active Energy Export': '反向有功电能',
        'Active Energy Net': '净有功电能',

        'Generator': '发电机',

        // Photovoltaic Power Station
        'Invertor': '逆变器',
        'Invertor Run State': '逆变器运行状态',
        'Invertor Unknown': '未知',
        'Invertor Initializing': '初始上电',
        'Invertor Standby': '待机',
        'Invertor Shutdown': '关机',
        'Invertor Fault': '故障',
        'Invertor Running': '运行',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': '生成时间',
        'File Format': '文件格式',
        'File Size': '文件大小',
        Uploader: '上传者',
        'Upload Datetime': '上传时间',
        //Error
        "The page you're looking for is not found": '您要找的页面不存在',
        "Make sure the address is correct and that the page hasn't moved": '请确认地址正确且页面没有被移动',
        'If you think this is a mistake,': '如果您认为这是一个错误,',
        'contact us': '联系我们',
        'Take me home': '带我回首页',
        'Whoops, something went wrong!': '哦, 出错了！!',
        'Try refreshing the page, or going back and attempting the action again':
            '请尝试刷新页面, 或回退并再次尝试执行这个操作',
        'If this problem persists,': '如果问题依然存在,',
        'Captcha Error': '验证码错误',
        'Confirm Password Error': '两次密码不一致',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            '看起来你点击了一个无效的重置密码链接。请再试一次。',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            '看起来你点击了一个无效的注册账号链接。请再试一次。',
        //Tenant Bill
        'Lease Contract Number': '租赁合同号码',
        Download: '下载',
        Print: '打印',
        'Payment Notice': '付款通知书',
        'Bill To': '致',
        'Bill Number': '账单号码',
        'Bill Date': '账单日期',
        'Payment Due Date': '付款到期日',
        'Amount Payable': '应付款金额',
        'Billing Period Start': '结算期起始日期',
        'Billing Period End': '结算期结束日期',
        Quantity: '数量',
        Price: '价格',
        Unit: '单位',
        Amount: '金额',
        Subtotal: '小计',
        'VAT Output Tax': '增值税销项税金',
        'Total Amount Payable': '应付金额合计',
        'Please make sure to pay on or before the payment due date above': '请确保在上述付款到期日或之前付款',
        'Send money to the following account': '汇款至以下账户',
        'Account Name': '账户名称',
        'Bank Name': '开户银行',
        'Bank Address': '银行地址',
        'RMB Account': '人民币账户',
        // button
        'Toggle Navigation': '切换导航',
        // working calendar
        'Working Days': '工作日',
        'Non Working Days': '非工作日',
        'Select Row': '请选择要操作的数据行',
        // Offline Meter Input
        'Daily Value': '日数据',
        Date: '日期',
        'Successfully Saved': '保存成功',
        'Previous Data Is Empty': '之前的数据为空',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': '管理员会话不存在',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': '管理员会话已超时',
        'API.ADVANCED_REPORT_NOT_FOUND': '高级报表不存在',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': '错误请求',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': '不能将已经设为分表的计量表设置为总表',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': '组合设备与设备关系已存在',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': '组合设备与设备关系不存在',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': '组合设备与计量表关系已存在',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': '组合设备与计量表关系不存在',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': '组合设备名称已使用',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': '组合设备不存在',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '组合设备与离线表关系已存在',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '组合设备与离线表关系不存在',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '组合设备相关参数名称已使用',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '组合设备相关参数不存在或不匹配',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '组合设备与虚拟表关系已存在',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '组合设备与虚拟表关系不存在',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': '联系人姓名已使用',
        'API.CONTACT_NOT_FOUND': '联系人不存在',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': '成本中心外部ID已存在',
        'API.COST_CENTER_NAME_EXISTS': '成本中心名称已存在',
        'API.COST_CENTER_NOT_FOUND': '成本中心不存在',
        'API.COST_FILE_NOT_FOUND': '成本文件不存在',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': '数据源名称已使用',
        'API.DATA_SOURCE_NOT_FOUND': '数据源不存在',
        'API.DATABASE_ERROR': '数据库错误',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': '日期已在工作日历中',
        'API.DATE_LOCAL_NOT_FOUND': '未找到本地日期',
        'API.DEEPSEEK_INVALID_RESPONSE': 'AI 分析返回格式无效',
        'API.DEEPSEEK_NOT_CONFIGURED': '服务端未配置 AI 分析（DeepSeek）',
        'API.DEEPSEEK_REQUEST_FAILED': 'AI 分析请求失败',
        'API.DEEPSEEK_UPSTREAM_ERROR': 'AI 分析服务暂时不可用',
        'API.DEEPSEEK_TOO_MANY_MESSAGES': '本会话消息条数已超过上限（最多 5 条）',
        'API.INVALID_MESSAGE_CONTENT': '无效的消息内容',
        'API.INVALID_MESSAGE_ROLE': '无效的消息角色',
        'API.INVALID_MESSAGES': '无效的消息列表',
        'API.INVALID_REPORT_CONTEXT': '无效的报表上下文',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': '配电回路名称已使用',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': '配电回路不存在',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': '配电回路与点位关系已存在',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': '配电回路与点位关系不存在',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': '配电系统名称已使用',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': '配电系统不存在',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': '电子邮箱已使用',
        'API.EMAIL_MESSAGE_NOT_FOUND': '电子邮件消息不存在',
        'API.EMAIL_NOT_FOUND': '电子邮箱不存在',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': '邮件服务器主机已使用',
        'API.EMAIL_SERVER_NOT_FOUND': '邮件服务器主机不存在',
        'API.EMPTY_VARIABLES_ARRAY': '空变量数组',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': '能源分类名称已使用',
        'API.ENERGY_CATEGORY_NOT_FOUND': '能源分类不存在',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': '能源分类在能源分项中已使用',
        'API.ENERGY_CATEGORY_USED_IN_METER': '能源分类在计量表中已使用',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': '能源分类在离线表中已使用',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': '能源分类在费率中已使用',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': '能源分类在虚拟表中已使用',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': '能流图链接已使用',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': '能流图链接不存在或不匹配',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': '能流图名称已使用',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': '能流图节点已使用',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': '能流图节点不存在或不匹配',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': '能流图不存在',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': '能源分项不属于能源分类',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': '能源分项不属于能源分类',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': '能源分项已使用',
        'API.ENERGY_ITEM_NOT_FOUND': '能源分项不存在',
        'API.ENERGY_ITEM_USED_IN_METER': '能源分项在计量表中已使用',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': '能源分项在离线表中已使用',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': '能源分项在虚拟表中已使用',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': '设备与计量表关系已存在',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': '设备与计量表关系不存在',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': '设备名称已使用',
        'API.EQUIPMENT_NOT_FOUND': '设备不存在',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '设备与离线表关系已存在',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '设备与离线表关系不存在',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '设备相关参数名称已使用',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '设备相关参数不存在或不匹配',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '设备与虚拟表关系已存在',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '设备与虚拟表关系不存在',
        'API.ERROR': '错误',
        'API.EXCEPTION': '异常',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': '恢复成本文件失败',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': '恢复知识文件失败',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': '恢复离线表文件失败',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': '保存离线表文件失败',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': '上传成本文件失败',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': '上传知识文件失败',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': '上传离线表文件失败',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': '网关名称已使用',
        'API.GATEWAY_NOT_FOUND': '网关不存在',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': '无效的 ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': '无效地址',
        'API.INVALID_ADDRESS_VALUE': '无效地址值',
        'API.INVALID_ADVANCED_REPORT_ID': '无效的高级报表ID',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': '无效面积值',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': '无效的基准期结束时间',
        'API.INVALID_BASE_PERIOD_START_DATETIME': '无效的基准期开始时间',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': '无效波特率',
        'API.INVALID_BUILDINGS_VALUE': '无效的建筑值',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': '无效类型',
        'API.INVALID_CHANNEL': '无效通道',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': '无效的组合设备ID',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': '无效的组合设备名称',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': '无效的组合设备相关参数ID',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': '无效的组合设备相关参数名称',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': '无效的组合设备相关参数类型',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': '无效的组合设备UUIDs',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': '无效连接',
        'API.INVALID_CONSTANT_VALUE': '无效常量值',
        'API.INVALID_CONTACT_ID': '无效的联络人ID',
        'API.INVALID_CONTACT_NAME': '无效的联络人姓名',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': '无效的成本中心ID',
        'API.INVALID_COST_FILE_ID': '无效的成本文件ID',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': '无效的数据源ID',
        'API.INVALID_DATA_SOURCE_NAME': '无效的数据源名称',
        'API.INVALID_DATA_SOURCE_PROTOCOL': '无效的数据源协议',
        'API.INVALID_DATE_LOCAL': '无效的本地日期',
        'API.INVALID_DENOMINATOR_METER_UUID': '无效的标准计量表UUID',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': '无效的显示名称',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': '无效的配电回路ID',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': '无效的配电回路名称',
        'API.INVALID_DISTRIBUTION_ROOM': '无效的配电室',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': '无效的配电系统ID',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': '无效的配电系统名称',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': '无效的邮箱',
        'API.INVALID_EMAIL_MESSAGE_ID': '无效的电子邮件ID',
        'API.INVALID_EMAIL_SERVER_HOST': '无效的电子邮箱服务器主机',
        'API.INVALID_EMAIL_SERVER_ID': '无效的电子邮箱服务器ID',
        'API.INVALID_END_DATE_FORMAT': '无效的结束日期格式',
        'API.INVALID_END_DATETIME': '无效的结束日期',
        'API.INVALID_ENERGY_CATEGORY_ID': '无效的能源分类ID',
        'API.INVALID_ENERGY_CATEGORY_NAME': '无效的能源分类名称',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': '无效的能流图ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': '无效的能流图链接ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': '无效的能流图名称',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': '无效的能流图节点ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': '无效的能流图节点名称',
        'API.INVALID_ENERGY_ITEM_ID': '无效的能源分项ID',
        'API.INVALID_ENERGY_ITEM_NAME': '无效的能源分项名称',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': '表达式中无效的表达式',
        'API.INVALID_EQUIPMENT_ID': '无效的设备ID',
        'API.INVALID_EQUIPMENT_NAME': '无效的设备名称',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': '无效的设备相关参数ID',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': '无效的设备相关参数名称',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': '无效的设备相关参数类型',
        'API.INVALID_EQUIPMENT_UUID': '无效的设备UUID',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': '无效表达式',
        'API.INVALID_EXPRESSION_OBJECT': '无效的表达式对象',
        'API.INVALID_FDD_CODE': '无效的故障错误码',
        'API.INVALID_FLOORS_VALUE': '无效的楼层值',
        'API.INVALID_FROM_ADDR': '无效地址',
        'API.INVALID_GATEWAY_ID': '无效的网关ID',
        'API.INVALID_GATEWAY_NAME': '无效的网关名称',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': '无效的小时上限值',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': '无效的小时下限值',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': '无效的管理值',
        'API.INVALID_IS_COST_DATA_DISPLAYED': '无效的是否显示成本数据',
        'API.INVALID_IS_COUNTED_VALUE': '无效的计数值',
        'API.INVALID_IS_ENABLED': '无效的是否启用',
        'API.INVALID_IS_HIDDEN': '无效的是否隐藏',
        'API.INVALID_IS_IN_LEASE_VALUE': '无效的是否在租值',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': '无效的输入是否汇总值',
        'API.INVALID_IS_KEY_TENANT_VALUE': '无效的是否主力租户值',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': '无效的输出是否汇总值',
        'API.INVALID_IS_OUTPUT_VALUE': '无效的输出是否汇总值',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': '无效的是否保存趋势值',
        'API.INVALID_IS_VIRTUAL_VALUE': '无效的是否虚拟点值',
        'API.INVALID_KGCE': '无效的千克标准煤系数',
        'API.INVALID_KGCO2E': '无效的千克二氧化碳排放系数',
        'API.INVALID_KNOWLEDGE_FILE_ID': '无效的知识文件ID',
        'API.INVALID_LATITUDE_VALUE': '无效的纬度值',
        'API.INVALID_LEASE_NUMBER_VALUE': '无效的租约编号',
        'API.INVALID_LONGITUDE_VALUE': '无效的经度值',
        'API.INVALID_LOW_LIMIT_VALUE': '无效的下限值',
        'API.INVALID_MASTER_METER_ID': '无效的总计量表ID',
        'API.INVALID_MENU_ID': '无效的菜单ID',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': '无效的消息模板',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': '无效的计量表ID',
        'API.INVALID_METER_NAME': '无效的计量表名称',
        'API.INVALID_METER_UUID': '无效的计量表UUID',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': '无效的名称值',
        'API.INVALID_NEW_PASSWORD': '无效的新密码',
        'API.INVALID_NON_WORKING_DAY_ID': '无效的非工作日ID',
        'API.INVALID_NOTIFICATION_ID': '无效的通知ID',
        'API.INVALID_NUMERATOR_METER_UUID': '无效的分子表UUID',
        'API.INVALID_OBJECT_TYPE': '无效的对象类型',
        'API.INVALID_OFFLINE_METER_DATA': '无效离线表数据',
        'API.INVALID_OFFLINE_METER_FILE_ID': '无效的离线表文件ID',
        'API.INVALID_OFFLINE_METER_ID': '无效的离线表ID',
        'API.INVALID_OFFLINE_METER_NAME': '无效的离线表名称',
        'API.INVALID_OFFLINE_METER_UUID': '无效的离线表UUID',
        'API.INVALID_OFFSET_CONSTANT_VALUE': '无效的偏移常量',
        'API.INVALID_OLD_PASSWORD': '无效的旧密码',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': '无效的父空间ID',
        'API.INVALID_PASSWORD': '无效的密码',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': '无效峰值电流',
        'API.INVALID_PEAK_LOAD': '无效峰值负载',
        'API.INVALID_PERIOD_TYPE': '无效周期类型',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': '无效的数据点ID',
        'API.INVALID_POINT_NAME': '无效的数据点名称',
        'API.INVALID_PORT': '无效端口',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': '无效的优先级',
        'API.INVALID_PRIVILEGE': '无效的权限',
        'API.INVALID_PRIVILEGE_DATA': '无效的权限数据',
        'API.INVALID_PRIVILEGE_ID': '无效的权限ID',
        'API.INVALID_PRIVILEGE_NAME': '无效的权限名称',
        'API.INVALID_RATIO_VALUE': '无效的变比值',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': '无效回复',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': '无效的报告期结束日期时间',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': '无效的报告期开始日期时间',
        'API.INVALID_REQUIRES_AUTHENTICATION': '无效的需要身份验证',
        'API.INVALID_ROOMS_VALUE': '无效的房间值',
        'API.INVALID_RULE_ID': '无效的规则ID',
        'API.INVALID_RULE_NAME': '无效的规则名称',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': '无效的传感器ID',
        'API.INVALID_SENSOR_NAME': '无效的传感器名称',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': '无效的串口号',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': '会话无效，请重新登陆',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': '无效的车间ID',
        'API.INVALID_SHOPFLOOR_NAME': '无效的车间名称',
        'API.INVALID_SHOPFLOOR_UUID': '无效的车间UUID',
        'API.INVALID_SOURCE_NODE_ID': '无效的源节点ID',
        'API.INVALID_SPACE_ID': '无效的空间ID',
        'API.INVALID_SPACE_NAME': '无效的空间名称',
        'API.INVALID_SPACE_UUID': '无效的空间UUID',
        'API.INVALID_START_DATE_FORMAT': '无效的开始时间格式',
        'API.INVALID_START_DATETIME': '无效的开始时间',
        'API.INVALID_STATUS': '无效状态',
        'API.INVALID_STORE_ID': '无效门店ID',
        'API.INVALID_STORE_NAME': '无效门店名称',
        'API.INVALID_STORE_TYPE_DESCRIPTION': '无效的门店类型描述',
        'API.INVALID_STORE_TYPE_ID': '无效的门店类型ID',
        'API.INVALID_STORE_TYPE_NAME': '无效的门店类型名称',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': '无效的门店类型简化代码',
        'API.INVALID_STORE_UUID': '无效门店UUID',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': '无效SVG',
        'API.INVALID_SWITCHGEAR': '无效的开关设备',
        'API.INVALID_TARGET_NODE_ID': '无效的目标节点ID',
        'API.INVALID_TARIFF_BLOCK_PRICING': '无效的阶梯费率定价',
        'API.INVALID_TARIFF_ID': '无效的费率ID',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': '无效的分时费率定价',
        'API.INVALID_TARIFF_TYPE': '无效的费率类型',
        'API.INVALID_TENANT_ID': '无效的租户ID',
        'API.INVALID_TENANT_NAME': '无效的租户名称',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': '无效的租户类型描述',
        'API.INVALID_TENANT_TYPE_ID': '无效的租户类型ID',
        'API.INVALID_TENANT_TYPE_NAME': '无效的租户类型名称',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': '无效的租户类型简化代码',
        'API.INVALID_TENANT_UUID': '无效的租户UUID',
        'API.INVALID_TEXT_MESSAGE_ID': '无效的短信ID',
        'API.INVALID_TIMEZONE_ID': '无效的时区ID',
        'API.INVALID_TOKEN': '无效令牌',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': '无效的计量单位',
        'API.INVALID_UNIT_OF_PRICE': '无效的价格单位',
        'API.INVALID_UNITS': '无效单位',
        'API.INVALID_USER_ID': '无效的用户ID',
        'API.INVALID_USER_NAME': '无效的用户名称',
        'API.INVALID_USER_NAME_OR_EMAIL': '无效的用户名称或邮箱',
        'API.INVALID_USER_PHONE': '无效的用户手机号',
        'API.INVALID_USER_PLEASE_RE_LOGIN': '无效的用户请重新登录',
        'API.INVALID_USER_UUID': '无效的用户UUID',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': '无效的变量计量表ID',
        'API.INVALID_VARIABLE_METER_TYPE': '无效的变量计量表类型',
        'API.INVALID_VARIABLE_NAME': '无效的变量名称',
        'API.INVALID_VERIFICATION_CODE': '无效的验证码',
        'API.INVALID_VIRTUAL_METER_ID': '无效的虚拟表ID',
        'API.INVALID_VIRTUAL_METER_NAME': '无效的虚拟表名称',
        'API.INVALID_VIRTUAL_METER_UUID': '无效的虚拟表UUID',
        'API.INVALID_WEB_MESSAGE_ID': '无效的web消息ID',
        'API.INVALID_WECHAT_MESSAGE_ID': '无效的微信消息ID',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': '无效的工作日历ID',
        'API.INVALID_WORKING_CALENDAR_NAME': '无效的工作日历名称',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': '无法从磁盘中删除知识文件',
        'API.KNOWLEDGE_FILE_NOT_FOUND': '知识库文件不存在',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': '总表不属于同一能源分类',
        'API.MASTER_METER_NOT_FOUND': '总表不存在',
        'API.MENU_NOT_FOUND': '菜单不存在',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': '计量表名称已使用',
        'API.METER_NOT_FOUND': '计量表不存在',
        'API.METER_OF_VARIABLE_NOT_FOUND': '计量表变量不存在',
        'API.METER_POINT_RELATION_EXISTS': '计量表与数据点关系已存在',
        'API.METER_POINT_RELATION_NOT_FOUND': '计量表与数据点关系不存在',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '新密码长度不能超过100个字符',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': '非工作日不存在',
        'API.NOT_FOUND': '不存在',
        'API.NOTIFICATION_NOT_FOUND': '通知不存在',
        'API.OFFLINE_METER_FILE_NOT_FOUND': '离线表文件不存在',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': '离线表名称已使用',
        'API.OFFLINE_METER_NOT_FOUND': '离线表不存在',
        'API.INVALID_OFFLINE_METER_VALUE': '无效的离线数据',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': '离线表变量不存在',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '旧密码长度不能超过100个字符',
        'API.PARENT_SPACE_NOT_FOUND': '父空间不存在',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '密码长度不能超过100个字符',
        'API.PASSWORDS_MATCH': '新密码与旧密码一致',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': '数据点名称已使用',
        'API.POINT_NOT_FOUND': '数据点不存在',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': '权限名称已使用',
        'API.PRIVILEGE_NOT_FOUND': '权限不存在',
        'API.RULE_NAME_IS_ALREADY_IN_USE': '规则名称已使用',
        'API.RULE_NOT_FOUND': '规则不存在',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': '传感器名称已使用',
        'API.SENSOR_NOT_FOUND': '传感器不存在',
        'API.SENSOR_POINT_RELATION_EXISTS': '传感器与数据点关系已存在',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': '传感器与数据点关系不存在',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': '车间与设备关系已存在',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': '车间与设备关系不存在',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': '车间与计量表关系已存在',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': '车间与计量表关系不存在',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': '车间名称已使用',
        'API.SHOPFLOOR_NOT_FOUND': '车间不存在',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': '车间与离线表关系已存在',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': '车间与离线表关系不存在',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': '车间与数据点关系已存在',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': '车间与数据点关系不存在',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': '车间与传感器关系已存在',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': '车间与传感器关系不存在',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': '车间与虚拟表关系已存在',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': '车间与虚拟表关系不存在',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': '车间工作日历关系已存在',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': '车间与工作日历关系不存在',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': '源节点不存在',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': '空间与组合设备关系已存在',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': '空间与组合设备关系不存在',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': '空间与设备关系已存在',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': '空间与设备关系不存在',
        'API.SPACE_METER_RELATION_EXISTS': '空间与计量表关系已存在',
        'API.SPACE_METER_RELATION_NOT_FOUND': '空间与计量表关系不存在',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': '空间名称已使用',
        'API.SPACE_NOT_FOUND': '空间不存在',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': '空间在权限中不存在',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': '空间与离线表关系已存在',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': '空间与离线表关系不存在',
        'API.SPACE_POINT_RELATION_EXISTS': '空间与数据点关系已存在',
        'API.SPACE_POINT_RELATION_NOT_FOUND': '空间与数据点关系不存在',
        'API.SPACE_SENSOR_RELATION_EXISTS': '空间与传感器关系已存在',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': '空间与传感器关系不存在',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': '空间与车间关系已存在',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': '空间与车间关系不存在',
        'API.SPACE_STORE_RELATION_EXISTS': '空间与门店关系已存在',
        'API.SPACE_STORE_RELATION_NOT_FOUND': '空间与门店关系不存在',
        'API.SPACE_TENANT_RELATION_EXISTS': '空间与租户关系已存在',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': '空间与租户关系不存在',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': '空间与虚拟表关系已存在',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': '空间与虚拟表关系不存在',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': '空间与工作日历关系已存在',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': '空间与工作日历关系不存在',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': '开始日期时间必须早于结束日期时间',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': '门店与计量表关系已存在',
        'API.STORE_METER_RELATION_NOT_FOUND': '门店与计量表关系不存在',
        'API.STORE_NAME_IS_ALREADY_IN_USE': '门店名称已使用',
        'API.STORE_NOT_FOUND': '门店不存在',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': '门店与离线表关系已存在',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': '门店与离线表关系不存在',
        'API.STORE_POINT_RELATION_EXISTS': '门店与数据点关系已存在',
        'API.STORE_POINT_RELATION_NOT_FOUND': '门店与数据点关系不存在',
        'API.STORE_SENSOR_RELATION_EXISTS': '门店与传感器关系已存在',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': '门店传感器关系不存在',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': '门店类型名称已使用',
        'API.STORE_TYPE_NOT_FOUND': '门店类型不存在',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '门店类型简化代码已使用',
        'API.STORE_TYPE_USED_IN_STORE': '门店类型在门店中已使用',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': '门店与虚拟表关系已存在',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': '门店与虚拟表关系不存在',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': '门店与工作日历关系已存在',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': '门店与工作日历关系不存在',
        'API.TARGET_NODE_NOT_FOUND': '目标节点不存在',
        'API.TARIFF_IN_USE': '费率正在使用',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': '费率和成本中心已关联',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': '费率和成本中心未关联',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': '费率名称已使用',
        'API.TARIFF_NOT_FOUND': '费率不存在',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': '租户与计量表关系已存在',
        'API.TENANT_METER_RELATION_NOT_FOUND': '租户与计量表关系不存在',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': '租户名称已使用',
        'API.TENANT_NOT_FOUND': '租户不存在',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': '租户与离线表关系已存在',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': '租户与离线表关系不存在',
        'API.TENANT_POINT_RELATION_EXISTS': '租户与数据点关系已存在',
        'API.TENANT_POINT_RELATION_NOT_FOUND': '租户与数据点关系不存在',
        'API.TENANT_SENSOR_RELATION_EXISTS': '租户与传感器关系已存在',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': '租户与传感器关系不存在',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': '租户与类型名称已使用',
        'API.TENANT_TYPE_NOT_FOUND': '租户类型不存在',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '租户类型简化代码已使用',
        'API.TENANT_TYPE_USED_IN_TENANT': '租户类型在租户中已使用',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': '租户与虚拟表关系已存在',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': '租户与虚拟表关系不存在',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': '租户与工作日历关系已存在',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': '租户与工作日历关系不存在',
        'API.TEXT_MESSAGE_NOT_FOUND': '未找到短信',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': '报告期必须大于15分钟',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': '与子表有关系',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': '与子空间有关系',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': '与组合设备相关参数有关系',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': '与组合设备有关系',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': '与数据源有关系',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': '与能流图有关系',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': '与储能集装箱电池有关系',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': '与储能集装箱电网有关系',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': '与储能集装箱负载有关系',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': '与储能集装箱功率转换系统(PCS)有关系',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': '与设备相关参数有关系',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': '与设备有关系',
        'API.THERE_IS_RELATION_WITH_METER': '与计量表有关系',
        'API.THERE_IS_RELATION_WITH_METERS': '与多个记量表有关系',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': '与离线表有关系',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': '与多个离线表有关系',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': '与虚拟表有关系',
        'API.THERE_IS_RELATION_WITH_SENSORS': '与传感器有关系',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': '与车间有关系',
        'API.THERE_IS_RELATION_WITH_SPACES': '与空间有关系',
        'API.THERE_IS_RELATION_WITH_STORES': '与门店有关系',
        'API.THERE_IS_RELATION_WITH_TENANTS': '与租户有关系',
        'API.THERE_IS_RELATION_WITH_USERS': '与用户有关系',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': '与虚拟表有关系',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': '与虚拟电厂有关系',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': '这个数据源正在被一个计量表使用',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '这个计量表正在被一个虚拟表使用',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '这个离线表正在被一个虚拟表使用',
        'API.THIS_SPACE_CANNOT_BE_CLONED': '空间不能被克隆',
        'API.THIS_SPACE_CANNOT_BE_DELETED': '空间不能被删除',
        'API.TIMEZONE_NOT_FOUND': '时区不存在',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '未找到令牌，请登录',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': '用户帐号已锁定',
        'API.USER_ACCOUNT_HAS_EXPIRED': '用户帐号已过期',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': '用户名已使用',
        'API.USER_NOT_FOUND': '用户不存在',
        'API.USER_PASSWORD_HAS_EXPIRED': '用户密码已过期',
        'API.USER_PRIVILEGE_NOT_FOUND': '未发现用户权限',
        'API.USER_SESSION_NOT_FOUND': '未发现用户会话',
        'API.USER_SESSION_TIMEOUT': '用户会话已过期',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '用户UUID不存在，请登录',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': '虚拟表名称已使用',
        'API.VIRTUAL_METER_NOT_FOUND': '虚拟表不存在',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': '变量的虚拟表不存在',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': '虚拟数据点应该是模拟量',
        'API.WEB_MESSAGE_NOT_FOUND': 'web信息不存在',
        'API.WECHAT_MESSAGE_NOT_FOUND': '微信信息不存在',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': '工作日历名称已使用',
        'API.WORKING_CALENDAR_NOT_FOUND': '工作日历不存在',

        MasterMeter: '总表',
        SubMeter: '分表',
        'Power Quality': '电能质量',
        'About Power Quality': '关于电能质量',
        Category: '类别',
        Type: '类型',
        Limit: '限值',
        'Normal Limit': '正常限值',
        'Severe Limit': '严重限值',
        Compliance: '合规率',
        'Worst Deviation': '最差偏差',
        'Worst Time': '最差发生时间',
        'Severe Exceed Count': '严重越限次数',
        'Worst Unbalance': '最大不平衡率',
        Hz: '赫兹',
        voltage: '电压',
        current: '电流',
        frequency: '频率',
        voltage_deviation: '电压偏差',
        current_unbalance: '电流不平衡',
        voltage_unbalance: '电压不平衡',
        mean_deviation_pct: '平均偏差(%)',
        p95_abs_deviation_pct: 'P95绝对偏差(%)',
        mean_abs_deviation_hz: '平均绝对偏差(Hz)',
        frequency_deviation: '频率偏差',
        p95_abs_deviation_hz: 'P95绝对偏差(Hz)',
        mean_unbalance_pct: '平均不平衡率(%)',
        p95_unbalance_pct: 'P95不平衡率(%)',
        count: '计数',
        min: '最小值',
        max: '最大值',
        mean: '平均值',
        std: '标准差',
        p5: 'P5',
        p95: 'P95'
    }
};
